export default "__VITE_ASSET__3db15a1e__"